export const autoLogout ={
  data() {
      return {
        events:['click','mousemove','mousedown','scroll','keypress','load'],
        warningTimer:null,
        logoutTimer:null,
        warningZone:false,
        currentRoute:''
      };
  },
  mounted()
  {
      if(this.$store.getters.isAuthenticated)
      {
          this.events.forEach(function(event)
          {
            window.addEventListener(event, this.resetTimer);
          }, this);          
           
          this.setTimers();
          
          
      }
  },
  unmounted(){
      this.events.forEach(function(event)
      {
        window.removeListener(event, this.resetTimer);
      }, this);
      this.resetTimer();
  },
  methods:{
      setTimers()
      {
        this.warningTimer = setTimeout(this.warningMessage, 20 * 60 * 1000); //14분 14 * 60 * 1000
        this.logoutTimer = setTimeout(this.logoutUser, 20 *  60 * 1000 +5000); //16분 16 * 60 * 1000

        this.warningZone = false;
      },
      warningMessage(){
          this.warningZone = true;
          //alert('일정시간 활동이 없어 로그아웃');
          console.log('일정시간 활동이 없어 5초후 로그아웃');
      },
      resetTimer()
      {
        clearTimeout(this.warningTimer);
        clearTimeout(this.logoutTimer);
        this.$store.dispatch("refreshExpire");
        this.setTimers();
      },
      logoutUser()
      {
        //채팅방 제외
        const chatromm = ["chat_room", "chat_mtm"];
        let chatroute = chatromm.includes(this.$route.name);
        //alert(this.$route.name);
        if( !chatroute )
        {
          //alert('로그아웃 되었습니다.');
          console.log('로그아웃');

          //document.getElementById('logout-form').submit();
          //채팅창에 있을때는 로그아웃 제외
          this.$store.dispatch("logout");
          //this.$router.replace('/');
          if(opener)
          {
            opener.location.reload();
          }else{
            window.location.reload();
          }
        }
      }
  }

}
